// extracted by mini-css-extract-plugin
export default {"news_display_box":"index_news_display_box_BlJt2","top_news":"index_top_news_Q5lN2","top_news_title":"index_top_news_title_Scq1C","top_news_item":"index_top_news_item_x--v2"};